module.exports = "<div layout=\"row\" layout-align=\"center\">\n  <md-card flex flex-gt-md=\"66\" class=\"card-no-padding\">\n    <competitors user=\"user\"></competitors>\n  </md-card>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./routes/account/competitors/competitors.tpl.html
// module id = 1149
// module chunks = 0